
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"width":"80px","height":"41px"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 79.1 41","style":"width:80px;height:41px"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 0H4C1.8 0 0 1.8 0 4v33c0 2.2 1.8 4 4 4h16c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zm3 37c0 1.7-1.3 3-3 3H4c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3h4c0 .6.4 1 1 1h6c.6 0 1-.4 1-1h4c1.7 0 3 1.3 3 3v33zM77.2 9.7C75 7 71 5.6 65.3 5.5l2.4-2.2c.2-.2.2-.5 0-.7s-.5-.2-.7 0l-3.4 3.2c-.1.1-.2.2-.2.4s.1.3.2.4l3.6 2.8c.1.1.2.1.3.1.1 0 .3-.1.4-.2.2-.2.1-.5-.1-.7l-2.6-2c5.4.1 9.1 1.4 11.2 3.8 2.1 2.4 1.6 5.3 1.6 5.3 0 .3.1.5.4.6h.1c.2 0 .4-.2.5-.4 0-.2.5-3.4-1.8-6.2zM72 17H37c-2.5 0-4.5 2-4.5 4.5V36c0 2.5 2 4.5 4.5 4.5h35c2.5 0 4.5-2 4.5-4.5V21.5c0-2.5-2-4.5-4.5-4.5zm3.5 7.2c-.1-.1-.3-.2-.5-.2-.6 0-1 .4-1 1v6c0 .6.4 1 1 1 .2 0 .4-.1.5-.2V36c0 1.9-1.6 3.5-3.5 3.5H37c-1.9 0-3.5-1.6-3.5-3.5V21.5c0-1.9 1.6-3.5 3.5-3.5h35c1.9 0 3.5 1.6 3.5 3.5v2.7z"}}),_c('path',{attrs:{"d":"M7.9 16h8v1h-8zM46.3 24h17.3v1H46.3zM5.9 20h12v1h-12zM42.3 28h25.3v1H42.3zM5.9 24h12v1h-12z"}}),_c('g',[_c('path',{attrs:{"d":"M47.3 32h15.3v1H47.3z"}})])])
          )
        }
      }
    